import { useMemo } from 'react';
import { useApplication } from '/utilities/application';

export const useApplicationSupport = (feature) => {
	const { hasApplicationInterface, supportedAppFeatures } = useApplication();

	return useMemo(() => {
		return (hasApplicationInterface && supportedAppFeatures.includes(feature));
	}, [hasApplicationInterface, supportedAppFeatures, feature]);
};
